import { useCallback } from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';
import { BannerMediaFiles } from '../../../../../types/brands/banner-media';

export const useSaveAvatarContent = () => {
  const { callEndpoint } = useAPIContext();

  const saveAvatarContent = useCallback(
    async (projectId: string, model: string, posterUrl?: string, mediaFiles?: BannerMediaFiles[]) => {
      try {
        const res = await callEndpoint<AvatarsAPI, 'save-avatar-content'>('avatars', '/content/save', 'POST', {
          projectId,
          model,
          posterUrl,
          mediaFiles
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error) {
        console.error('Error al guardar avatar content:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { saveAvatarContent };
};
